import * as React from 'react';
import { H2 } from '../../../designSystem/typography/Heading';
import { getAllIndicatorsWithCount } from '../../../amorg-common';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { Survey } from '../../../amorg-common';
import { Pill } from '../../../designSystem/pill/Pill';
import { PageSection } from '../../../designSystem/PageSection';

type IndicatorPanelProps = {
    survey:Survey
}
export function IndicatorPanel(props:IndicatorPanelProps):JSX.Element
{

    const allIndicators = getAllIndicatorsWithCount(props.survey);

    return (
        <PageSection
            header={<H2 color="gray">Indikatorer i brug</H2>}
        >
            <Flex flexDirection="row" gap={16} flexWrap='wrap'>
                {allIndicators.map(i => <Pill key={i.indicator} identifier={i.indicator}>{i.indicator} ({i.count})</Pill>)}

                {allIndicators.length === 0 &&
                    <p>Der er ikke oprettet nogen indikatorer. Med indikatorer kan du gruppere spørgsmål på tværs af temaer. Indikatorer redigeres for spørgsmål individuelt.</p>
                }
            </Flex>
        </PageSection>
    );
}